import { Box, Stack } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { Button } from "@src/appV2/redesign/components/Button";
import { ShiftCardWrapper } from "@src/appV2/redesign/Shift/Card/Wrapper";
import { mergeSxProps, Text } from "@src/appV2/redesign/system/ui-components";
import type { ReactNode } from "react";

const CTA_LABEL = "See shifts further away";

interface TravelForMoreShiftsCardViewProps {
  readonly distanceInMiles: number;
  readonly shiftPreviewSlot: ReactNode;
  readonly onCtaClick: () => void;
  readonly sx?: SxProps<Theme>;
}

export function TravelForMoreShiftsCardView(props: TravelForMoreShiftsCardViewProps) {
  const { distanceInMiles, shiftPreviewSlot, onCtaClick, sx } = props;

  return (
    <ShiftCardWrapper
      sx={mergeSxProps(
        (theme) => ({
          paddingX: theme.spacing(5),
          paddingY: theme.spacing(8),
        }),
        sx
      )}
    >
      <Stack gap={7}>
        <Stack gap={3} alignItems="center">
          <Text variant="body2" textAlign="center">
            You have seen all shifts within {distanceInMiles} mi radius
          </Text>
          <Text semibold variant="h4" textAlign="center">
            Travel for more shifts?
          </Text>
        </Stack>

        <Box sx={{ position: "relative", paddingTop: (theme) => theme.spacing(6) }}>
          <Box
            aria-hidden
            sx={(theme) => ({
              position: "absolute",
              top: 0,
              left: theme.spacing(6),
              right: theme.spacing(6),
              bottom: theme.spacing(6),
              borderRadius: theme.borderRadius?.medium,
              backgroundColor: theme.palette.background.secondary,
              border: `1px solid ${theme.palette.border?.primary}`,
              zIndex: 0,
            })}
          />
          <Box
            aria-hidden
            sx={(theme) => ({
              position: "absolute",
              top: theme.spacing(3),
              left: theme.spacing(3),
              right: theme.spacing(3),
              bottom: theme.spacing(3),
              borderRadius: theme.borderRadius?.medium,
              backgroundColor: theme.palette.background.primary,
              border: `1px solid ${theme.palette.border?.primary}`,
              zIndex: 1,
            })}
          />
          <Box sx={{ position: "relative", zIndex: 2 }}>{shiftPreviewSlot}</Box>
        </Box>

        <Button onClick={onCtaClick}>{CTA_LABEL}</Button>
      </Stack>
    </ShiftCardWrapper>
  );
}
